export default __webpack_public_path__ + "65260e3776f834ae62ff989e362d3bbd.svg";